<template>
  <div class="collection-hero critical-component-clear container grid">
    <div class="col xs4 l1-5">
      <h1
        class="
          collection-hero__title
          text-heading-2xl
          text-heading-5xl-desktop
        "
        v-text="title"
      />
    </div>

    <div
      class="
        collection-hero__info
        col xs4 l7-11
        text-body-s text-body-m-desktop
      "
    >
      <span
        class="collection-hero__description text-body-s text-body-m-desktop"
        v-text="description.slice(0, descriptionLimit)"
      />

      <span
        v-if="expanded"
        class="collection-hero__description text-body-s text-body-m-desktop"
        v-text="description.slice(descriptionLimit)"
      />&nbsp;<a
        v-if="description.length > descriptionLimit"
        class="
          splash-section__cta-text
          text-body-s-link
          text-body-m-link-desktop
        "
        @click="expanded = !expanded"
        v-text="ctaLinkText"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Collection hero (collection-hero)
 * -----------------------------------------------------------------------------
 * Collection Hero.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'CollectionHero',

  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    descriptionLimit: {
      type: Number,
      default: 140,
    },
  },

  data() {
    return {
      expanded: false,
    }
  },

  computed: {

    /**
     * Returns read more link text
     */
    ctaLinkText() {
      return this.expanded ? this.$string('collection.read_less') : this.$string('collection.read_more')
    },
  },
}
</script>

<style lang="scss">
@import './collection-hero';
</style>
